import { RicosViewer } from "./../ricos-viewer-next";
import { createWixRicosViewer } from "./WixRicosViewerNext";
export * from "./../wix-ricos-common";
const WixRicosViewer = createWixRicosViewer(RicosViewer);
export {
  WixRicosViewer
};
//# sourceMappingURL=index.js.map
